export default "__VITE_ASSET__nmpAaZZ7__"